module.exports = __webpack_public_path__ + "static/media/green-round-tick.67e20e22.svg";